import { apiClient } from "../apiClient";

export const QUAN_LY_API_ENDPOINT = "quan-ly-api";

/** Màn Tài liệu API (soạn tài liệu tích hợp gửi đối tác) — chỉ tài khoản kỹ thuật (namviet/namvietdev). */
export const quanLyApiApi = {
  Select: () => apiClient.get(QUAN_LY_API_ENDPOINT),

  /** Tên + mô tả tự viết cho 1 API (để trống cả hai = quay về tên có sẵn). */
  LuuTuyChinh: (payload: { key: string; ten: string; mo_ta: string }) =>
    apiClient.post(`${QUAN_LY_API_ENDPOINT}/tuy-chinh`, payload),

  LuuThongTinChung: (payload: { gioi_thieu: string; dia_chi_goc: string }) =>
    apiClient.post(`${QUAN_LY_API_ENDPOINT}/thong-tin-chung`, payload),

  // ===== Liên kết chia sẻ ra ngoài =====
  DanhSachChiaSe: () => apiClient.get(`${QUAN_LY_API_ENDPOINT}/chia-se`),

  /** so_ngay = 0: không thời hạn. kieu "token": các API trong liên kết nhận token đối tác. */
  TaoChiaSe: (payload: { ten: string; keys: string[]; so_ngay: number; kieu: "token" | "cong_khai" }) =>
    apiClient.post(`${QUAN_LY_API_ENDPOINT}/chia-se`, payload),

  ThuHoiChiaSe: (ma: string) => apiClient.post(`${QUAN_LY_API_ENDPOINT}/chia-se/${ma}/thu-hoi`),

  XoaChiaSe: (ma: string) => apiClient.delete(`${QUAN_LY_API_ENDPOINT}/chia-se/${ma}`),

  /** Trang CÔNG KHAI /tai-lieu-api/{ma} — không cần đăng nhập. */
  XemChiaSe: (ma: string) => apiClient.get(`tai-lieu-api/${encodeURIComponent(ma)}`),
};

/** Đường dẫn trang công khai của 1 liên kết (dùng địa chỉ đang mở hệ thống). */
export const DUONG_DAN_CHIA_SE = "/tai-lieu-api/";
/** API lấy TOKEN ĐỐI TÁC (khóa API đối tác nối vào cuối) — dùng cho API đối tác và liên kết kiểu "Lấy token". */
export const API_LAY_TOKEN_DOI_TAC = "/api/ngan-hang/get-token/";
export const lienKetChiaSe = (ma: string) => `${window.location.origin}${DUONG_DAN_CHIA_SE}${ma}`;
